import Router from 'vue-router';
import Home from './views/Home.vue';

const TuitionTutorialMobile = () => import('./views/TuitionTutorialMobile.vue');

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/tuition_tutorial',
      component: TuitionTutorialMobile,
    },
  ],
});
